<script setup>
/**
 * Verkoop-sidebar. Bootstrap (categorieën) komt uit PHP.
 * Verhuur blijft in features/column-left/.
 */
import VerhuurColumnLeft from '@verhuur/column-left/ColumnLeftApp.vue';
</script>

<template>
  <div class="vsb-verkoop-column-left">
    <VerhuurColumnLeft />
  </div>
</template>

<style scoped>
/* Verkoop-merkblauw (#004494) i.p.v. Verhuur-navy (#0b3d91) */
.vsb-verkoop-column-left :deep(.vsb-column-left__title) {
  color: #004494;
}
.vsb-verkoop-column-left :deep(.vsb-col-nav__link--active) {
  color: #004494;
  background: #e8f0fa;
}
.vsb-verkoop-column-left :deep(.vsb-col-nav__link--parent-active),
.vsb-verkoop-column-left :deep(.vsb-col-nav__link:hover) {
  color: #004494;
}
</style>
